import { render, staticRenderFns } from "./EditCompanyNotesModal.vue?vue&type=template&id=5cc83f48&scoped=true&"
import script from "./EditCompanyNotesModal.vue?vue&type=script&lang=ts&"
export * from "./EditCompanyNotesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc83f48",
  null
  
)

export default component.exports